<div class="frame-slider">
  <h3>{{ title }}</h3>

  <div class="frames-container">
    <!-- LEFT BUTTON -->
    <button class="nav-btn minimal left" (click)="filterMode ? scrollFiltersLeft() : scrollLeft()">
      <svg viewBox="0 0 24 24">
        <polyline points="9 18 15 12 9 6"></polyline>
      </svg>
    </button>

    <!-- FRAME or FILTER LIST -->
   <div class="frames-wrapper" #framesWrapper>
      <!-- Filter Mode -->
          <ng-container *ngIf="filterMode; else frameList">
            <div
              *ngFor="let filter of filters; let i = index"
              class="filterIcons"
            >
              <div>
                <div [style.border-color]="filter.selected">
                  <img
                    class="frame-bg"
                    (click)="selectItem(filter, i)"
                    src="https://prod-cdn.singsnap.com/assets/images/video_fx_preview.jpeg?w=150"
                    [style.filter]="filter.preview"
                  />
                </div>
                <p>{{ filter.name }}</p>
              </div>
            </div>
          </ng-container>


      <!-- Frame Mode -->
      <ng-template #frameList>
        <div *ngFor="let frame of framesPaths" class="filterIcons">
          <div *ngIf="recorder?.frames[frame.name]">
            <div
              class="item-box"
              [style.border-color]="recorder.frames[frame.name].selected"
            >
              <img
                class="frame-bg"
                (click)="selectItem(frame)"
                src="https://prod-cdn.singsnap.com/assets/images/video_fx_preview.jpeg?w=150"
                alt="frame background"
              />
              <img
                class="framesPreview"
                (click)="selectItem(frame)"
                [src]="recorder.frames[frame.name].src"
                alt="{{ frame.name }}"
              />
            </div>
            <p class="item-name">{{ frame.name }}</p>
          </div>
        </div>
      </ng-template>
    </div>

    <!-- RIGHT BUTTON -->
    <button class="nav-btn minimal right" (click)="filterMode ? scrollFiltersRight() : scrollRight()">
      <svg viewBox="0 0 24 24">
        <polyline points="9 18 15 12 9 6"></polyline>
      </svg>
    </button>
  </div>
</div>
